<template>
    <div class="row">
        <div class="col-12 col-lg-4 order-lg-2">
            <account-sidebar
                :lng="lng"
                :mainlng="mainlng"
                :translations="translations"
                :accountlink="accountlink"
                :logoutlink="logoutlink"
                :isaccountroute="isaccountroute"
                :account="accountSidebar"
                v-on:AvatarChanged="changeAvatar($event)"
                :refillaccountlink="refillaccountlink"

            ></account-sidebar>
        </div>
        <div class="col-12 col-lg-8 order-lg-1">
            <notification-alert-block v-for="(notification, key) in preparedNotifications" :notification="notification"
                                      :setnotificationlink="setnotificationlink" :key="key"></notification-alert-block>
            <div class="simple__block">
                <h3 class="h5">{{ get_translation_constant('text_personal_data') }}</h3>
                <form action="">
                    <template v-if="account.location_id == 1">
                        <div class="row align-items-end">
                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('first_name')">
                                    <label>{{
                                            get_translation_constant('text_firstname_cyrillic')
                                        }}<sup>*</sup></label>
                                    <input
                                        class="form__control"
                                        :placeholder="get_translation_constant('text_your_firstname')"
                                        type="text"
                                        v-model="form.first_name"
                                    >
                                    <div class="form__error" v-if="hasErrorMessage('first_name')">
                                        {{ hasErrorMessage('first_name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('last_name')">
                                    <label>{{
                                            get_translation_constant('text_lastname_cyrillic')
                                        }}<sup>*</sup></label>
                                    <input class="form__control"
                                           :placeholder="get_translation_constant('text_your_lastname')"
                                           type="text"
                                           v-model="form.last_name">
                                    <div class="form__error" v-if="hasErrorMessage('last_name')">
                                        {{ hasErrorMessage('last_name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-end">
                                <div class="col-12 col-lg-6">
                                    <div class="form__col" :class="hasError('first_name_latin')">
                                        <label>{{
                                                get_translation_constant('text_firstname_latin')
                                            }}<sup>*</sup></label>
                                        <input
                                            class="form__control"
                                            :placeholder="get_translation_constant('text_your_firstname')"
                                            type="text"
                                            v-model="form.first_name_latin"
                                        >
                                        <div class="form__error" v-if="hasErrorMessage('first_name_latin')">
                                            {{ hasErrorMessage('first_name_latin') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="form__col" :class="hasError('last_name_latin')">
                                        <label>{{
                                                get_translation_constant('text_lastname_latin')
                                            }}<sup>*</sup></label>
                                        <input class="form__control"
                                               :placeholder="get_translation_constant('text_your_lastname')"
                                               type="text"
                                               v-model="form.last_name_latin">
                                        <div class="form__error" v-if="hasErrorMessage('last_name_latin')">
                                            {{ hasErrorMessage('last_name_latin') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('patronymic')">
                                    <label>{{
                                            get_translation_constant('text_patronymic_cyrillic')
                                        }}</label>
                                    <input class="form__control"
                                           :placeholder="get_translation_constant('text_patronymic')"
                                           type="text"
                                           v-model="form.patronymic">
                                    <div class="form__error" v-if="hasErrorMessage('patronymic')">
                                        {{ hasErrorMessage('patronymic') }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('birthday')">
                                    <label>{{
                                            get_translation_constant('text_birthday')
                                        }}</label>

                                    <date-picker v-model="form.birthday"
                                                 class="form__control"
                                                 @dp-hide="showDatePicker"
                                                 :locale="lng"
                                                 :config="{format:'DD-MM-YYYY', locale:lng}"></date-picker>
                                    <div class="form__error" v-if="hasErrorMessage('birthday')">
                                        {{ hasErrorMessage('birthday') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </template>
                    <template v-else>
                        <div class="row align-items-end">
                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('first_name_latin')">
                                    <label>{{
                                            get_translation_constant('text_firstname_latin')
                                        }}<sup>*</sup></label>
                                    <input
                                        class="form__control"
                                        :placeholder="get_translation_constant('text_your_firstname')"
                                        type="text"
                                        v-model="form.first_name_latin"
                                    >
                                    <div class="form__error" v-if="hasErrorMessage('first_name_latin')">
                                        {{ hasErrorMessage('first_name_latin') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('last_name_latin')">
                                    <label>{{
                                            get_translation_constant('text_lastname_latin')
                                        }}<sup>*</sup></label>
                                    <input class="form__control"
                                           :placeholder="get_translation_constant('text_your_lastname')"
                                           type="text"
                                           v-model="form.last_name_latin">
                                    <div class="form__error" v-if="hasErrorMessage('last_name_latin')">
                                        {{ hasErrorMessage('last_name_latin') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row align-items-end">
                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('first_name')">
                                    <label>{{
                                            get_translation_constant('text_firstname_english')
                                        }}<sup>*</sup></label>
                                    <input
                                        class="form__control"
                                        :placeholder="get_translation_constant('text_your_firstname')"
                                        type="text"
                                        v-model="form.first_name"
                                    >
                                    <div class="form__error" v-if="hasErrorMessage('first_name')">
                                        {{ hasErrorMessage('first_name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('last_name')">
                                    <label>{{
                                            get_translation_constant('text_lastname_english')
                                        }}<sup>*</sup></label>
                                    <input class="form__control"
                                           :placeholder="get_translation_constant('text_your_lastname')"
                                           type="text"
                                           v-model="form.last_name">
                                    <div class="form__error" v-if="hasErrorMessage('last_name')">
                                        {{ hasErrorMessage('last_name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('patronymic')">
                                    <label>{{
                                            get_translation_constant('text_patronymic')
                                        }}</label>
                                    <input class="form__control"
                                           :placeholder="get_translation_constant('text_patronymic')"
                                           type="text"
                                           v-model="form.patronymic">
                                    <div class="form__error" v-if="hasErrorMessage('patronymic')">
                                        {{ hasErrorMessage('patronymic') }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('birthday')">
                                    <label>{{
                                            get_translation_constant('text_birthday')
                                        }}</label>

                                    <date-picker v-model="form.birthday"
                                                 class="form__control"
                                                 @dp-hide="showDatePicker"
                                                 :locale="lng"
                                                 :config="{format:'DD-MM-YYYY', locale:lng}"></date-picker>
                                    <div class="form__error" v-if="hasErrorMessage('birthday')">
                                        {{ hasErrorMessage('birthday') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>



                    <div class="form__col" :class="hasError('gender')">
                        <label>{{ get_translation_constant('text_sex') }}</label>
                        <div class="row no-gutters radio_group__custom">
                            <div v-for="(gender, index) in genders" class="col-auto radio_group__item">
                                <input v-model="form.gender_id" :id="gender.title" name="sex" type="radio"
                                       @click="setGender(gender)" :value="gender.id">
                                <label :for="gender.title">{{ genderTitle(gender) }}</label>
                            </div>
                        </div>
                        <div class="form__error" v-if="hasErrorMessage('gender')">
                            {{ hasErrorMessage('gender') }}
                        </div>
                    </div>
                    <div class="row form__address">
                        <div v-if="account.location_id !== 1" class="col-12 col-lg-6">
                            <div class="form__col" :class="hasError('city_id')">
                                <label>{{ get_translation_constant('text_your_city') }}<sup>*</sup></label>
                                <multiselect v-model="form.city"
                                             class="form-control"
                                             :multiple="false"
                                             :placeholder="get_translation_constant('text_choose_city')"
                                             :options="cities"
                                             label="title"
                                             selectLabel=""
                                             deselectLabel=""
                                             :optionHeight="48"
                                             :showPointer="true"
                                             @select="setAccountCity()"
                                >
                                    <template></template>
                                </multiselect>
                                <div class="form__error" v-if="hasErrorMessage('city_id')">
                                    {{ hasErrorMessage('city_id') }}
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-12 col-lg-6">
                            <div class="form__col"
                                 :class="hasError('form.city_ref')">
                                <label>{{
                                        get_translation_constant('text_your_city')
                                    }}<sup>*</sup></label>
                                <multiselect v-model="form.city_ref"
                                             class="form-control"
                                             :multiple="false"
                                             :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                             :options="form.novaPoshtaCities"
                                             label="Description"
                                             selectLabel=""
                                             deselectLabel=""
                                             :optionHeight="48"
                                             :showPointer="true"
                                             @search-change="asyncCities"
                                             @select="loadStreets"
                                >
                                </multiselect>
                                <div class="form__error"
                                     v-if="hasErrorMessage('city_ref')">
                                    {{ get_translation_constant('text_field_is_required') }}
                                </div>
                            </div>
                        </div>
                        <div v-if="account.location_id === 1" class="col-12 col-lg-6">
                            <div class="form__col"
                                 :class="hasError('form.street')">
                                <label>{{
                                        get_translation_constant('text_delivery_street')
                                    }}</label>
                                <multiselect v-model="form.street"
                                             class="form-control"
                                             :multiple="false"
                                             :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                             :options="form.streets"
                                             label="Description"
                                             selectLabel=""
                                             deselectLabel=""
                                             :optionHeight="48"
                                             :showPointer="true"
                                             @search-change="searchTimeOut"
                                >
                                </multiselect>
                                <div class="form__error"
                                     v-if="hasErrorMessage('deliveryMethod.novaPoshta.street')">
                                    {{ get_translation_constant('text_field_is_required') }}
                                </div>
                            </div>
                        </div>

                        <template v-if="account.location_id === 1" >
                            <div  class="col-12 col-lg-6">
                                <div class="form__col" :class="hasError('buildingNumber')">
                                    <label for="address">{{
                                            get_translation_constant('text_choose_house')
                                        }}<sup>*</sup></label>
                                    <input v-model="form.buildingNumber" class="form__control" id="buildingNumber" name="buildingNumber"
                                           type="text"
                                           :placeholder="get_translation_constant('text_choose_house')">

                                    <div class="form__error" v-if="hasErrorMessage('buildingNumber')">
                                        {{ hasErrorMessage('buildingNumber') }}
                                    </div>
                                </div>
                            </div>
                            <div  class="col-12 col-lg-6">
                                <div class="form__col" >
                                    <label for="flat">{{
                                            get_translation_constant('text_your_flat')
                                        }}</label>
                                    <input v-model="form.flat" class="form__control" id="flat" name="flat"
                                           type="text"
                                           :placeholder="get_translation_constant('text_enter_flat')">
                                </div>
                            </div>
                            <div  class="col-12 col-lg-6">
                                <div class="form__col" >
                                    <label for="postcode">{{
                                            get_translation_constant('text_your_postcode')
                                        }}</label>
                                    <input v-model="form.postcode" class="form__control" id="postcode" name="postcode"
                                           type="text"
                                           :placeholder="get_translation_constant('text_enter_postcode')">
                                </div>
                            </div>
                        </template>




                        <div v-if="account.location_id !== 1" class="col-12 col-lg-6">
                            <div class="form__col" :class="hasError('address')">
                                <label for="address">{{
                                        get_translation_constant('text_your_address')
                                    }}<sup>*</sup></label>
                                <input v-model="form.address" class="form__control" id="address" name="address"
                                       type="text"
                                       :placeholder="get_translation_constant('text_enter_address_latin_letters')">

                                <div class="form__error" v-if="hasErrorMessage('address')">
                                    {{ hasErrorMessage('address') }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <div class="form__col" :class="hasError('email')">
                                <label for="email">{{ get_translation_constant('text_email') }}<sup>*</sup></label>
                                <input v-model="form.email" class="form__control" id="email" name="email"
                                       type="email"
                                       :placeholder="get_translation_constant('text_entry_email')">
                                <div class="form__error" v-if="hasErrorMessage('email')">
                                    {{ hasErrorMessage('email') }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="form__col" :class="hasError('phone_number')">
                                <label>{{ get_translation_constant('text_phone') }}<sup>*</sup></label>
                                <div class="phone__block">
                                    <multiselect v-model="form.phone_prefix"
                                                 class="form-control"
                                                 :multiple="false"
                                                 :placeholder="''"
                                                 :options="locationPrefixes"
                                                 label="title"
                                                 selectLabel=""
                                                 deselectLabel=""
                                                 :optionHeight="48"
                                                 :showPointer="true"
                                                 :searchable="false"
                                    >
                                        <template slot="singleLabel" slot-scope="props">
                                            <img class="option__image" :src="props.option.image" width="16">
                                            <span class="option__title">{{ props.option.title }}</span>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <img class="option__image" :src="props.option.image" width="16">
                                            <span class="option__title">{{ props.option.title }}</span>
                                        </template>
                                    </multiselect>
                                    <input class="form__control type_tel" v-model="form.phone_number" type="tel">
                                </div>
                                <div class="form__error" v-if="hasErrorMessage('phone_number')">
                                    {{ hasErrorMessage('phone_number') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-check form-switch">
                        <input checked class="form-check-input" id="notification"
                               name="notification" type="checkbox" v-model="form.use_sms">
                        <label class="form-check-label"
                               for="notification">{{
                                get_translation_constant('text_get_sms')
                            }}</label>
                    </div>

                    <div class="form-check form-switch">
                        <input class="form-check-input" id="code" name="code" type="checkbox"
                               v-model="form.use_terminal">
                        <label class="form-check-label"
                               for="code">{{
                                get_translation_constant('text_get_terminal_code')
                            }}</label>
                    </div>

                    <div class="form-check form-switch">
                        <input class="form-check-input" id="autoDeclaration" name="autodeclaration" type="checkbox"
                               v-model="form.auto_declaration">
                        <label class="form-check-label"

                               for="autoDeclaration">{{
                                get_translation_constant('text_get_auto_declaration')
                            }}</label>
                    </div>

                    <div class="form__hr"></div>

                    <div class="row align-items-center">
                        <div class="collapse col-12" id="changePassword">
                            <div class="card card-body">
                                <div class="row">
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('old_password')">
                                            <label>{{
                                                    get_translation_constant('text_old_password')
                                                }}
                                                <sup>*</sup></label>
                                            <input v-model="form.old_password" class="form__control" id="old_password"
                                                   name="old_password" type="password"
                                                   :placeholder="get_translation_constant('text_old_password')">
                                            <div class="form__error" v-if="hasErrorMessage('old_password')">
                                                {{ hasErrorMessage('old_password') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('new_password')">
                                            <label>{{
                                                    get_translation_constant('text_new_password')
                                                }}<sup>*</sup></label>
                                            <input v-model="form.new_password"
                                                   class="form__control"
                                                   id="new_password"
                                                   name="new_password"
                                                   type="password"
                                                   :placeholder="get_translation_constant('text_new_password')">
                                            <div class="form__error" v-if="hasErrorMessage('new_password')">
                                                {{ hasErrorMessage('new_password') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('new_password_check')">
                                            <label>{{
                                                    get_translation_constant('text_confirm_password')
                                                }}
                                                *<sup>*</sup></label>
                                            <input v-model="form.new_password_check"
                                                   class="form__control"
                                                   id="new_password_check"
                                                   name="new_password_check"
                                                   :placeholder="get_translation_constant('text_new_password_check')"
                                                   type="password">
                                            <div class="form__error" v-if="hasErrorMessage('new_password_check')">
                                                {{ hasErrorMessage('new_password_check') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center justify-content-between">
                        <div class="col-12 col-md-6 mb-3 mb-md-0">
                            <a ref="changePasswordId" class="change__password" href="#changePassword"
                               aria-controls="changePassword" aria-expanded="false" data-bs-toggle="collapse"
                               role="button">{{ get_translation_constant('text_change_password') }}</a>
                        </div>
                        <div class="col-12 col-md-auto text-lg-right d-flex">
                            <input class="btn btn__large btn__green btn__block" type="submit"
                                   @click.prevent="submitForm()"
                                   :value="get_translation_constant('text_save_settings')">
                        </div>
                    </div>
                </form>
            </div>
            <div class="simple__block">
                <h3 class="h5 d-flex align-items-center">{{ get_translation_constant('text_agents') }}<span
                    class="tooltip__block tooltip__bottom tooltip__modal">
                                            <span class="tooltip__block_trigger">
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                                        fill="#515154"/>
                                                </svg>
                                            </span>
                                            <span class="tooltip__block_overlay">
                                                            <span class="tooltip__block_inner">
                                                                <span class="tooltip__block_close"></span>
                                                                <p>{{
                                                                        get_translation_constant('text_creating_agents_is_relevant')
                                                                    }}</p>
                                                <p><a href="#">{{
                                                        get_translation_constant('text_learn_more_about_agents')
                                                    }}</a></p>
                                            </span>
                                            </span>
                                        </span>
                </h3>
                <table class="table table__agents">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>{{ get_translation_constant('text_name_surname') }}</th>
                        <th v-if="account.location_id !== 1">{{ get_translation_constant('text_city') }}</th>
                        <th>{{ get_translation_constant('text_address') }}</th>
                        <th>{{ get_translation_constant('text_phone') }}</th>
                        <th v-if="account.location_id === 1">{{ get_translation_constant('text_parcel_count') }}</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(agent, key) in agents">
                        <td>{{ key + 1}}</td>
                        <td v-if="account.location_id === 1">{{ agent.first_name }} {{ agent.last_name }} {{ agent.patronymic }}</td>
                        <td v-else>{{ agent.first_name_latin }} {{ agent.last_name_latin }}</td>
                        <td v-if="account.location_id !== 1">{{ getCity(agent) }}</td>
                        <td>{{ agent.street }} {{ agent.house }} {{ agent.apartment }}</td>
                        <td><a :href="'tel:'+agent.phone_prefix+agent.phone_number">{{
                                agent.phone_prefix
                            }}{{ agent.phone_number }}</a></td>
                        <td v-if="account.location_id === 1">{{ agent.totals.cnt }}</td>
                        <td>
                            <div class="table__actions d-flex justify-content-end">
                                <a href="javascript:void(0)" @click.prevent="removeAgent(agent)" title="Remove">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z"
                                            fill="#515154"/>
                                    </svg>
                                </a>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="d-md-flex justify-content-end">
                    <a class="btn btn__large btn__blue_border no_width d-block" href="javascript:void(0)"
                       data-bs-toggle="modal"
                       data-bs-target="#addAgent">{{ get_translation_constant('text_add_agent') }}
                        +</a>
                </div>
            </div>
        </div>
        <!-- Modal Add Agent -->
        <div class="modal fade modal__custom" id="addAgent" tabindex="-1" role="dialog" aria-labelledby="addAgenttitle"
             aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <h4 class="h5 modal-title" id="addAgenttitle">{{
                                get_translation_constant('text_add_agent')
                            }}</h4>
                        <button type="button" id="closeAgentBtn" class="close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form action="">
                            <h5 class="h_text">{{ get_translation_constant('text_personal_data') }}</h5>
                            <div class="row">
                                <template v-if="account.location_id === 1">
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_first_name')">
                                            <label>{{ get_translation_constant('text_firstname_cyrillic') }}
                                                <sup>*</sup></label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_firstname_english')"
                                                type="text"
                                                v-model="newAgent.first_name"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_first_name')">
                                                {{ hasErrorMessage('newAgent_first_name') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_last_name')">
                                            <label>{{ get_translation_constant('text_firstname_cyrillic') }}
                                                <sup>*</sup></label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_lastname_english')"
                                                type="text"
                                                v-model="newAgent.last_name"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_last_name')">
                                                {{ hasErrorMessage('newAgent_last_name') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_first_name_latin')">
                                            <label>{{ get_translation_constant('text_firstname_latin') }}
                                                <sup>*</sup></label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_firstname_latin')"
                                                type="text"
                                                v-model="newAgent.first_name_latin"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_first_name_latin')">
                                                {{ hasErrorMessage('newAgent_first_name_latin') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_last_name_latin')">
                                            <label>{{ get_translation_constant('text_lastname_latin') }}
                                                <sup>*</sup></label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_lastname_latin')"
                                                type="text"
                                                v-model="newAgent.last_name_latin"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_last_name_latin')">
                                                {{ hasErrorMessage('newAgent_last_name_latin') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_patronymic')">
                                            <label>{{ get_translation_constant('text_patronymic_cyrillic') }}
                                            </label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_patronymic')"
                                                type="text"
                                                v-model="newAgent.patronymic"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_text_patronymic')">
                                                {{ hasErrorMessage('newAgent_text_patronymic') }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_first_name_latin')">
                                            <label>{{ get_translation_constant('text_firstname_latin') }}
                                                <sup>*</sup></label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_firstname_latin')"
                                                type="text"
                                                v-model="newAgent.first_name_latin"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_first_name_latin')">
                                                {{ hasErrorMessage('newAgent_first_name_latin') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_last_name_latin')">
                                            <label>{{ get_translation_constant('text_lastname_latin') }}
                                                <sup>*</sup></label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_lastname_latin')"
                                                type="text"
                                                v-model="newAgent.last_name_latin"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_last_name_latin')">
                                                {{ hasErrorMessage('newAgent_last_name_latin') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_first_name')">
                                            <label>{{ get_translation_constant('text_firstname_english') }}
                                                <sup>*</sup></label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_firstname_english')"
                                                type="text"
                                                v-model="newAgent.first_name"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_first_name')">
                                                {{ hasErrorMessage('newAgent_first_name') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_last_name')">
                                            <label>{{ get_translation_constant('text_lastname_english') }}
                                                <sup>*</sup></label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_lastname_english')"
                                                type="text"
                                                v-model="newAgent.last_name"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_last_name')">
                                                {{ hasErrorMessage('newAgent_last_name') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <div class="form__col" :class="hasError('newAgent_patronymic')">
                                            <label>{{ get_translation_constant('text_patronymic') }}
                                            </label>
                                            <input
                                                class="form__control" name="full_name_ro"
                                                :placeholder="get_translation_constant('text_patronymic')"
                                                type="text"
                                                v-model="newAgent.patronymic"
                                            >
                                            <div class="form__error" v-if="hasErrorMessage('newAgent_text_patronymic')">
                                                {{ hasErrorMessage('newAgent_text_patronymic') }}
                                            </div>
                                        </div>
                                    </div>
                                </template>



                                <div class="col-12 col-lg-6" v-if="account.location_id !==1">
                                    <div class="form__col" :class="hasError('newAgent_city')">
                                        <label>{{ get_translation_constant('text_your_city') }} <sup>*</sup></label>
                                        <multiselect v-model="newAgent.city"
                                                     class="form-control"
                                                     :multiple="false"
                                                     :placeholder="get_translation_constant('text_choose_city')"
                                                     :options="cities"
                                                     label="title"
                                                     selectLabel=""
                                                     deselectLabel=""
                                                     :optionHeight="48"
                                                     :showPointer="true"
                                        >
                                            <template></template>
                                        </multiselect>
                                        <div class="form__error" v-if="hasErrorMessage('newAgent_city')">
                                            {{ hasErrorMessage('newAgent_city') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="form__col" :class="hasError('newAgent_street')">
                                        <label for="address">{{ get_translation_constant('text_your_street') }}
                                            <sup>*</sup></label>
                                        <input v-model="newAgent.street" class="form__control" name="street"
                                               type="text"
                                               :placeholder="get_translation_constant('text_your_street')">
                                        <div class="form__error" v-if="hasErrorMessage('newAgent_street')">
                                            {{ hasErrorMessage('newAgent_street') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="form__col" :class="hasError('newAgent_house')">
                                        <label for="house">{{ get_translation_constant('text_your_house') }}
                                            <sup>*</sup></label>
                                        <input v-model="newAgent.house" class="form__control" name="house" id="house"
                                               type="text"
                                               :placeholder="get_translation_constant('text_your_house')">
                                        <div class="form__error" v-if="hasErrorMessage('newAgent_house')">
                                            {{ hasErrorMessage('newAgent_house') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="form__col" :class="hasError('newAgent_apartment')">
                                        <label for="apartment">{{ get_translation_constant('text_your_apartment') }}
                                            <!--                                            <sup>*</sup>--></label>
                                        <input v-model="newAgent.apartment" class="form__control" name="apartment"
                                               id="apartment"
                                               type="text"
                                               :placeholder="get_translation_constant('text_your_apartment')">
                                        <div class="form__error" v-if="hasErrorMessage('newAgent_apartment')">
                                            {{ hasErrorMessage('newAgent_apartment') }}
                                        </div>
                                    </div>
                                </div>
                                <div  class="col-12 col-lg-6" v-if="account.location_id ===1">
                                    <div class="form__col" :class="hasError('newAgent_postcode')">
                                        <label for="postcode">{{
                                                get_translation_constant('text_your_postcode')
                                            }}</label>
                                        <input v-model="newAgent.postcode" class="form__control"
                                               type="text"
                                               :placeholder="get_translation_constant('text_enter_postcode')">
                                    </div>
                                    <div class="form__error" v-if="hasErrorMessage('newAgent_postcode')">
                                        {{ hasErrorMessage('newAgent_postcode') }}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-lg-6">
                                    <div class="form__col"
                                         :class="hasError('newAgent_phone_prefix') || hasError('newAgent_phone_number')">
                                        <label>{{ get_translation_constant('text_phone') }} <sup>*</sup></label>
                                        <div class="phone__block">
                                            <multiselect v-model="newAgent.phone_prefix"
                                                         class="form-control"
                                                         :multiple="false"
                                                         :placeholder="''"
                                                         :options="locationPrefixes"
                                                         label="title"
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :optionHeight="48"
                                                         :showPointer="true"
                                                         :searchable="false"
                                            >
                                                <template slot="singleLabel" slot-scope="props">
                                                    <img class="option__image" :src="props.option.image" width="16">
                                                    <span class="option__title">{{ props.option.title }}</span>
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <img class="option__image" :src="props.option.image" width="16">
                                                    <span class="option__title">{{ props.option.title }}</span>
                                                </template>
                                            </multiselect>
                                            <input class="form__control type_tel" v-model="newAgent.phone_number"
                                                   type="tel">
                                            <div class="form__error"
                                                 v-if="hasErrorMessage('newAgent_phone_prefix') || hasError('newAgent_phone_number')">
                                                {{ hasErrorMessage('newAgent_phone_prefix') }}
                                                {{ hasErrorMessage('newAgent_phone_number') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="form__col form__col_no_label text-right">
                                        <input class="btn btn__large btn__green no_width" @click.prevent="addAgent()"
                                               type="submit"
                                               :value="get_translation_constant('text_add_agent')">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <alert-modal :title="modalTitle" :type="modalType" :message="modalMessage" :modalId="modalId"></alert-modal>
    </div>
</template>

<script>
export default {
    name: "Account",
    props: {
        account: {
            type: [Object]
        },
        translations: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        cities: {
            type: [Object, Array]
        },
        genders: {
            type: [Object, Array]
        },
        isaccountroute: {
            type: [Boolean],
            default: false
        },
        accountlink: {
            type: [String]
        },
        logoutlink: {
            type: [String]
        },
        locations: {
            type: [Object, Array]
        },
        addagentlink: {
            type: [String]
        },
        removeagentlink: {
            type: [String]
        },
        updateprofiletlink: {
            type: [String]
        },
        refillaccountlink: {
            type: [String]
        },
        setnotificationlink: {
            type: [String]
        },
        novaposhtacitysearchlink: {
            type: [String]
        },
        novaposhtastreetsearchlink: {
            type: [String]
        },
        accountupdatedsuccessfully: {
            type: [String, Boolean]
        },
    },
    methods: {
        genderTitle(gender){
            if(gender.id === 1){
                return this.get_translation_constant('text_male')
            }
            return this.get_translation_constant('text_female')

        },
        showDatePicker(tytr) {

        },
        hasError(error) {
            if (this.errors[error])
                return 'has__error';
        },
        hasErrorMessage(error) {
            if (this.errors[error])
                return this.errors[error][0];
        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        getCity(agent) {
            if ((typeof agent.city_id !== 'undefined') && (agent.city_id !== null) && (typeof agent.city_id !== 'undefined')) {
                return this.cities.find(city => city.id === agent.city_id)?.title;
            }
            return '';
        },
        setAccountCity() {
            if ((typeof this.form.city !== 'undefined') && (this.form.city !== null) && (typeof this.form.city.id !== 'undefined')) {
                this.form.city_id = this.form.city.id;
            } else {
                this.form.city_id = '';
            }
        },
        setGender(gender) {
            this.form.gender_id = gender.id;
        },
        removeAgent(agent) {
            axios.post(this.removeagentlink, agent).then(response => {
                if (response.status === 200) {
                    this.agents.splice(this.agents.indexOf(agent), 1);
                    this.clearNewAgentData();

                    this.modal.title = 'Success Delete message';
                    this.modal.type = 'success';
                    this.modal.message = 'Success Delete message'
                    document.getElementById('AlertModalBtn' + this.modal.id).click();
                }
            }).catch(error => {
                if (error.response.status === 422) {
                    this.modal.title = 'Error Delete message';
                    this.modal.type = 'error';
                    this.modal.message = 'Error Delete message'
                    document.getElementById('AlertModalBtn' + this.modal.id).click();
                }
                if (error.response.status === 500) {
                    this.errors = error.response.data.errors;
                    this.modal.title = 'Error Delete message';
                    this.modal.type = 'error';
                    this.modal.message = 'Error Delete message'
                    document.getElementById('AlertModalBtn' + this.modal.id).click();
                }
            });
        },
        clearNewAgentData() {
            this.newAgent.first_name = '';
            this.newAgent.last_name = '';
            this.newAgent.first_name_latin = '';
            this.newAgent.last_name_latin = '';
            this.newAgent.street = '';
            this.newAgent.apartment = '';
            this.newAgent.house = '';
            this.newAgent.patronymic = '';
            this.newAgent.city = '';
            this.newAgent.phone_number = '';
            this.newAgent.phone_prefix = '';
            this.errors = [];
        },
        addAgent() {
            let toValidate = {
                first_name: this.newAgent.first_name,
                last_name: this.newAgent.last_name,
                first_name_latin: this.newAgent.first_name_latin,
                last_name_latin: this.newAgent.last_name_latin,
                phone_number: this.newAgent.phone_number,
                phone_prefix: this.newAgent.phone_prefix,
                street: this.newAgent.street,
                house: this.newAgent.house,
                //  patronymic: this.newAgent.patronymic,
            }

            if (this.account.location_id === 1){
                toValidate['postcode'] = this.newAgent.postcode
            }
            if (this.account.location_id !== 1){
                toValidate['city'] = this.newAgent.city
            }
            if (Object.values(toValidate).some(elem => elem === '')) {
                let errorBag = {};
                for (let key in toValidate) {
                    if (toValidate[key] === '') {
                        errorBag = Object.assign(errorBag, {['newAgent_' + key]: [this.get_translation_constant('text_field_is_required')]})
                    }
                }
                this.errors = errorBag;
                return false;
            }
            let agent = {
                locale: this.lng,
                user_id: this.account.id,
                first_name: this.newAgent.first_name,
                last_name: this.newAgent.last_name,
                first_name_latin: this.newAgent.first_name_latin,
                last_name_latin: this.newAgent.last_name_latin,
                phone_number: this.newAgent.phone_number,
                phone_prefix: this.newAgent.phone_prefix.title,
                street: this.newAgent.street,
                house: this.newAgent.house,
                patronymic: this.newAgent.patronymic,
                user_location_id: this.account.location_id,
                apartment: this.newAgent.apartment,
                postcode: this.newAgent.postcode
            }
            if (this.account.location_id !== 1){
                agent['city_id'] = this.newAgent.city.id
            }

            axios.post(this.addagentlink, agent).then(response => {
                if (response.status === 200) {
                    this.agents.push(response.data.agent)
                    this.clearNewAgentData();
                    this.modal.title = this.get_translation_constant('text_success_add_agent_title');
                    this.modal.type = 'success';
                    this.modal.message = this.get_translation_constant('text_success_add_agent_text');
                    this.trigger.addAgent = true;
                    setTimeout(() => {
                        document.getElementById('closeAgentBtn').click()
                    }, 200)
                }
            }).catch(error => {
                if (error.response.status === 400) {
                    let errorBag = {};
                    for (let key in error.response.data.errors) {
                        errorBag = Object.assign(errorBag, {['newAgent_' + key]: [error.response.data.errors[key][0]]})
                    }
                    console.log(errorBag)
                    this.errors = errorBag;
                    // this.alert = error.response.data.errors;
                }
                if (error.response.status === 500) {
                    this.errors = error.response.data.errors;

                    this.modal.title = this.get_translation_constant('text_error_add_agent_title');
                    this.modal.type = 'error';
                    this.modal.message = this.get_translation_constant('text_error_add_agent_message');

                    setTimeout(() => {
                        document.getElementById('closeAgentBtn').click()
                    }, 200)
                }
            });

        },
        submitForm() {
            let user = {
                locale: this.lng,
                id: this.account.id,
                email: this.form.email,
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                first_name_latin: this.form.first_name_latin,
                last_name_latin: this.form.last_name_latin,
                address: this.form.address,
                gender_id: this.form.gender_id,
                use_terminal: this.form.use_terminal ? 1 : 0,
                use_sms: this.form.use_sms ? 1 : 0,
                auto_declaration: !!this.form.auto_declaration ? 1 : 0,
                phone_number: this.form.phone_number,
                phone_prefix: (typeof this.form.phone_prefix !== 'undefined') && (this.form.phone_prefix !== null) && (typeof this.form.phone_prefix.title !== 'undefined') ? this.form.phone_prefix.title : null,
                old_password: this.form.old_password,
                new_password: this.form.new_password,
                new_password_check: this.form.new_password_check,
                patronymic: this.form.patronymic,
                birthday: this.form.birthday,
            }

            //if ukraine
            if (this.account.location_id === 1) {
                user.city_ref = this.form.city_ref;
                user.buildingNumber = this.form.buildingNumber;
                user.street = this.form.street
                user.flat = this.form.flat;
                user.postcode = this.form.postcode;

            } else {
                user.city_id = (typeof this.form.city !== 'undefined') && (this.form.city !== null) && (typeof this.form.city.id !== 'undefined') ? this.form.city.id : null
            }

            let formData = new FormData();
            for (let key in user) {
                if (['city_ref', 'street'].includes(key)){
                    formData.append(key, JSON.stringify(user[key]))
                } else{
                    formData.append(key, user[key])
                }
            }
            if (this.form.avatar !== null) {
                formData.append('avatar', this.form.avatar)
            }

            axios.post(this.updateprofiletlink, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                if (response.status === 200) {
                    this.errors = [];
                    this.modal.title = this.get_translation_constant('text_success_update_account_title');
                    this.modal.type = 'success';
                    this.modal.message = this.get_translation_constant('text_success_update_account_message');
                    if (this.account.location_id === 1) {
                        if ( response.data.hasOwnProperty('data') &&  response.data.data.hasOwnProperty('change_email_request')) {
                            this.modal.title = this.get_translation_constant('text_email_change_request_title');
                            this.modal.message = this.get_translation_constant('text_email_change_request_message');
                        }
                    }
                    this.trigger.updateForm = true;
                    setTimeout(() => {
                        document.getElementById('AlertModalBtn' + this.modal.id).click();
                    }, 200)
                    this.updateSidebar();
                    if (this.avatar !== null) {
                        document.getElementById('image_avatar').setAttribute('src', this.avatar)
                    }
                }
            }).catch(error => {
                if (error.response.status === 400) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 500) {
                    this.errors = error.response.data.errors;

                    this.modal.title = this.get_translation_constant('text_error_update_title');
                    this.modal.type = 'error';
                    this.modal.message = this.get_translation_constant('text_error_update_message');

                    setTimeout(() => {
                        document.getElementById('AlertModalBtn' + this.modal.id).click();
                    }, 200)
                }
                if (this.hasError('old_password') || this.hasError('new_password') || this.hasError('new_password_check')) {
                    this.$refs.changePasswordId.click()
                }
            });


        },
        changeAvatar(data) {
            this.createImage(data)
            this.form.avatar = data;
        },
        updateSidebar() {
            this.accountSidebar.first_name_latin = this.form.first_name_latin;
            this.accountSidebar.last_name_latin = this.form.last_name_latin;
            document.getElementById('account_full_name').innerText = this.accountSidebar.first_name_latin + ' ' + this.accountSidebar.last_name_latin;
            document.getElementById('account_name').innerText = this.accountSidebar.first_name_latin;

        },
        createImage(file) {
            let image = new Image();
            let reader = new FileReader();
            reader.onload = (e) => {
                this.avatar = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        asyncCities(query) {
            if (query === '') {
                return;
            }
            axios.post(this.novaposhtacitysearchlink, {
                find_city: query
            }).then(response => {
                this.form.novaPoshtaCities = response.data
            });
        },
        asyncFind(query) {
            axios.post(this.novaposhtastreetsearchlink, {
                street_ref: this.form.city_ref.Ref,
                find_street: query
            }).then(response => {
                this.form.streets = response.data
            });
        },
        searchTimeOut(query) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.asyncFind(query)
            }, 1000);
        },

        loadStreets() {
            setTimeout(() => {
                axios.post(this.novaposhtastreetsearchlink, {
                    street_ref: this.form.city_ref.Ref,
                    find_street: ''
                }).then(response => {
                    this.form.streets = response.data
                });

            }, 500)
        },
    },
    computed: {
        modalTitle() {
            return this.modal.title
        },
        modalMessage() {
            return this.modal.message
        },
        modalType() {
            return this.modal.type
        },
        modalId() {
            return this.modal.id
        },
        preparedNotifications() {
            if (typeof this.account.notifications === 'undefined' || this.account.notifications === null) {
                return []
            }
            return this.account.notifications;
        }
    },
    data() {
        return {
            errors: [],
            form: {
                id: '',
                email: '',
                first_name: '',
                last_name: '',
                first_name_latin: '',
                last_name_latin: '',
                phone_prefix: '',
                phone_number: '',
                city_id: '',
                city: {
                    id: '',
                    title: ''
                },
                city_ref: null,
                novaPoshtaCities: [],
                gender_id: '',
                address: '',
                use_terminal: false,
                use_sms: false,
                auto_declaration: false,
                old_password: '',
                new_password: '',
                new_password_check: '',
                avatar: null,
                patronymic: '',
                birthday: '',
                buildingNumber: '',
                flat: '',
                street: '',
                streets: [],
                postcode: ''
            },
            agents: [],
            locationPrefixes: [],
            newAgent: {
                first_name: '',
                last_name: '',
                first_name_latin: '',
                last_name_latin: '',
                city: '',
                phone_number: '',
                phone_prefix: '',
                street: '',
                house: '',
                apartment: '',
                patronymic: '',
                postcode:''
            },
            modal: {
                type: 'success',
                title: '',
                message: '',
                id: 'Account'
            },
            trigger: {
                addAgent: false,
                updateForm: false
            },
            accountSidebar: {},
            avatar: null,
            timer: null,
            searchChange: false
        }
    },
    mounted() {
        const addAgentModal = document.getElementById('addAgent')
        addAgentModal.addEventListener('hidden.bs.modal', () => {
            if (this.trigger.addAgent) {
                setTimeout(() => {
                    const AlertModalBtn = document.getElementById('AlertModalBtn' + this.modal.id)
                    AlertModalBtn.click();
                }, 200)
                this.trigger.addAgent = false;
            }
        })

        this.form.phone_prefix = this.locationPrefixes.find((option) => {
            return option.title === this.account.phone_prefix;
        });
        if (typeof this.form.phone_prefix == 'undefined') {
            this.form.phone_prefix = this.locationPrefixes[0]
        }
        this.accountSidebar = this.account

        if (this.accountupdatedsuccessfully){
            this.modal.title = this.get_translation_constant('text_success_update_account_title');
            this.modal.type = 'success';
            this.modal.message = this.get_translation_constant('text_success_update_account_message')
            document.getElementById('AlertModalBtn' + this.modal.id).click();
        }
    },
    created() {
        this.form.email = this.account.email;
        this.form.first_name = this.account.first_name;
        this.form.last_name = this.account.last_name;
        this.form.first_name_latin = this.account.first_name_latin;
        this.form.last_name_latin = this.account.last_name_latin;
        this.form.city = this.account.city;
        if (this.account.city !== null) {
            this.form.city.title = this.account.city.title[this.lng];
        }
        this.form.city_id = ((this.account.city !== null) && (typeof this.account.city.id !== 'undefined')) ? this.account.city.id : '';
        this.form.gender_id = ((typeof this.account.gender !== 'undefined') && (this.account.gender !== null) && (typeof this.account.gender.id !== 'undefined')) ? this.account.gender.id : '';
        this.form.address = this.account.address;
        this.agents = this.account.agents;
        this.form.phone_number = this.account.phone_number;
        this.locationPrefixes = Object.values(this.locations.filter((location) => {
            return location.id === this.account.location_id
        })).map((location) => {
            return {
                image: location.image,
                title: location.phone_prefix
            };
        })
        this.newAgent.phone_prefix = this.locationPrefixes[0];
        this.form.auto_declaration = this.account?.auto_declaration;
        this.form.birthday = this.account?.birthday;
        this.form.patronymic = this.account?.patronymic;

        this.form.city_ref = ((typeof this.account.novaPoshtaAddress !== 'undefined') && (this.account.novaPoshtaAddress !== null) && (typeof this.account.novaPoshtaAddress.cityRef !== 'undefined')) ?
            {
                Area: this.account.novaPoshtaAddress.areaRef,
                AreaDescription: this.account.novaPoshtaAddress.areaDescription,
                Description: this.account.novaPoshtaAddress.cityName,
                Ref: this.account.novaPoshtaAddress.cityRef,
            } : '';
        this.form.buildingNumber = this.account.novaPoshtaAddress?.buildingNumber;
        this.form.flat = this.account.novaPoshtaAddress?.flat;
        this.form.street = {
            Ref: this.account.novaPoshtaAddress?.streetRef,
            Description: this.account.novaPoshtaAddress?.streetName
        }

        this.form.postcode = this.account.postcode;
    },
    watch:{
        'form.phone_number' :{
            handler(val, oldval){
                //ua, az
                if ([1,4].includes(this.account.location_id)){
                    if ((val.length) > 9){
                        this.form.phone_number = oldval;
                    }
                    return;
                }
                //md, bz
                if ((val.length) > 8){
                    this.form.phone_number = oldval;
                }

            }
        },
        'newAgent.phone_number' :{
            handler(val, oldval){
                //ua, az
                if ([1,4].includes(this.account.location_id)){
                    if ((val.length) > 9){
                        this.newAgent.phone_number = oldval;
                    }
                    return;
                }
                //md, bz
                if ((val.length) > 8){
                    this.newAgent.phone_number = oldval;
                }

            }
        }
    }
}
</script>

<style scoped>

</style>
